import { DEFAULT_DATE_FORMAT } from "@/constants";
import { SCHEDULE_FORM_WEEKDAY_KEYS } from "@/schemas/scheduleFormWeekdays";
import {
  CreateProjectSchedule,
  CreateProjectScheduleForm,
} from "@/types/projectSchedule";
import { DateTime } from "luxon";

export const generateScheduleSelectedDays = ({
  date_start,
  date_end,
  weekdays,
  every_second_week,
}: {
  date_start: string;
  date_end: string;
  weekdays: CreateProjectScheduleForm["weekdays"];
  every_second_week: boolean;
}): CreateProjectSchedule["dates"] => {
  const start = DateTime.fromISO(date_start);
  const end = DateTime.fromISO(date_end);

  if (!start.isValid || !end.isValid) {
    return [];
  }

  const startWeek = start.weekNumber;

  const selectedDays: CreateProjectSchedule["dates"] = [];

  for (let d = start; d <= end; d = d.plus({ days: 1 })) {
    const dayName = SCHEDULE_FORM_WEEKDAY_KEYS[d.weekday - 1];
    const isDaySelected = weekdays[dayName as keyof typeof weekdays];
    const currentWeek = d.weekNumber;
    const weekDifference = currentWeek - startWeek;
    const isSelectedWeek = !every_second_week || weekDifference % 2 === 0;

    if (isDaySelected && isSelectedWeek) {
      selectedDays.push(d.toFormat(DEFAULT_DATE_FORMAT));
    }
  }

  return selectedDays;
};
